import { BookMarkedIcon, SearchIcon } from 'lucide-react';

import { DetailRowSpec } from './DetailsRow';
import {
  KnowledgeBaseHead,
  SelectedSourcesHead,
  SourcesList,
  useKnowledgeSources,
} from './DocumentsMatched';
import { ConversationTurn } from '../../../types/conversation';

/**
 * The knowledge-base pair: the base that answered, carrying the sources it
 * retrieved, and below it the sources the answer actually cited.
 */
export const useKnowledgeBaseRows = (turn: ConversationTurn): DetailRowSpec[] => {
  const { collectionId } = useKnowledgeSources(turn);

  if (!collectionId) {
    return [];
  }

  return [
    {
      key: 'knowledge-base',
      icon: <BookMarkedIcon className="h-4 w-4" />,
      head: (
        <div className="flex flex-1 flex-col items-start gap-4 pb-2">
          <KnowledgeBaseHead turn={turn} />
          <SourcesList turn={turn} />
        </div>
      ),
    },
    {
      key: 'sources-selected',
      icon: <SearchIcon className="h-4 w-4" />,
      head: <SelectedSourcesHead turn={turn} />,
    },
  ];
};
